import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent {

  content = `<h4>What information do we collect</h4>
The Insider Trading Alerts Chrome extension notifies you about updates regarding the stock market and
legal insider trading as reported by sec.gov. Below we outline what information we collect.
<br><br>
<h4>E-mail & Payment information</h4>
If you upgrade and thus make a purchase we store your email address and the generated license key in our database.
We also save payment data as returned by Stripe, a trusted provider of payment processing software.
These data however, do not include credit card number or other personal data, except your email address.
If you want to delete your email address,
payment data and/or license key from our database, please send a request to insidertradingalerts@yahoo.com
with a request for deletion and we will oblige duly.
<br><br>
<h4>User generated information</h4>
All your preferences such as filters, settings and favorites are stored only on your device, not in our database.
<br><br>
<h4>Third party services</h4>
When you upgrade, third-party services will come in contact with some of your data.
Your data may be stored on their hardware. That does not mean they can access it.
The third party services are:<br>
Stripe - https://stripe.com/<br>
Google Firebase - https://firebase.google.com

<br><br>
<h4>Analytics</h4>
To be able to develop our extension in the best and most efficient way possible,
we use Google Analytics to get a high level, aggregated view of patterns in our product.
All data used is being passed and stored anonymously, and can’t be tied back to you.
<br><br>
<h4>Fonts</h4>
To give our extension the look-and-feel we like, we use Google Fonts.
<br><br>
<h4>Cookies</h4>
We do not store cookies on your device or in the browser.
<br><br>
<h4>Age Of Consent</h4>
By using this site and our extension, you represent that you are at least the age of majority in your state or province of residence,
or that you are the age of majority in your state or province of residence and you have given us your consent to
allow any of your minor dependents to use this site.
<br><br>
<h4>Changes To This Privacy Policy</h4>
We reserve the right to modify this privacy policy at any time, so please review it frequently.
Changes and clarifications will take effect immediately upon their posting on the website.
<br><br>
<h4>Questions And Contact Information</h4>
If you would like to register a complaint, or simply want more information please write to insidertradingalerts@yahoo.com.`;


}
